module.exports = __webpack_public_path__ + "img/Sibiu_d_kl.169f1e7e.jpg";